class VolumeDiscountCard {
  constructor(button) {
    this.button = button;
  }

  submit() {
    const quantity = parseInt(this.button.dataset.quantity, 10);
    if (!quantity || quantity < 1) return;

    const formId = this.button.dataset.formId;
    const root = this.button.closest('product-info') || document;

    const quantityInput = formId
      ? root.querySelector(`input[name="quantity"][form="${formId}"]`)
      : root.querySelector('input.quantity__input[name="quantity"]');

    if (quantityInput) {
      quantityInput.value = quantity;
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const form = formId ? root.querySelector(`form#${formId}`) : root.querySelector('product-form form');
    if (form) {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-volume-discount-add]');
  if (!button) return;
  event.preventDefault();
  new VolumeDiscountCard(button).submit();
});
